import { AmpRegistrationStatus } from "@redotech/redo-model/amp-registration-definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getTeamsAmpStatus = {
  name: "getTeamsAmpStatus" as const,
  input: z.object({
    pageContinue: z.string().optional(),
    pageSize: z.number().min(1).max(500).default(20),
    searchTerm: z.string().optional(),
    ampStatus: z
      .array(
        z.union([
          z.literal("not_registered"),
          createEnum(AmpRegistrationStatus),
        ]),
      )
      .optional(),
  }),
  output: z.object({
    data: z.array(
      z.object({
        teamId: zExt.objectId(),
        teamName: z.string(),
        dkimStatus: z.string().optional(),
        gmailAmpStatus: createEnum(AmpRegistrationStatus).optional(),
        lastUpdated: z.date().optional(),
        emailAddress: z.string(),
        lastRejectionEmailHtml: z.string().optional(),
      }),
    ),
    pageNext: z.string().optional(),
  }),
};
